import ArgumentLabel from '../arguments/ArgumentLabel.jsx';
import ArgumentWrapper from '../arguments/ArgumentWrapper.jsx';
import Toggle from '../Toggle.jsx';

const PanelToggle = ({ label, icon, description, valid, helpIconContext, active, onChange, disabled, labelProps = {}, className = '', title, size = 'sm' }) => {
  return (
    <ArgumentWrapper className={className}>
      <ArgumentLabel className="small-gap" label={label} icon={icon} description={description} valid={valid} helpIconContext={helpIconContext} {...labelProps} title={title}>
        <Toggle size={size} active={active} onChange={onChange} disabled={disabled} />
      </ArgumentLabel>
    </ArgumentWrapper>
  );
};

export default PanelToggle;
